import constants from "../constants";

const { INIT_BACNET_ADDRESSES_STORE, UPDATE_BACNET_ADDRESSES_STORE } = constants;

const initialState = {};

export default (state = initialState, action) => {
  const { type, bacnetAddresses, updates } = action;

  switch (type) {
    case INIT_BACNET_ADDRESSES_STORE:
      return bacnetAddresses;

    case UPDATE_BACNET_ADDRESSES_STORE: {
      const nextState = { ...state };

      updates.forEach((address) => {
        if (address?.id) nextState[address?.id] = { ...nextState[address?.id], ...address };
      });

      return nextState;
    }

    default:
      return state;
  }
};
